import PropTypes from "prop-types";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { LOAD_NETWORK } from "redux-store/networks";
import { SimpleFetchController } from "ui/fetch/fetch-controller/simple-fetch-controller";

function mapStateToProps(_state, props) {
  return {
    objectId: String(props.networkId),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    fetchObject: (networkId) => {
      return createPromiseApiAction(dispatch, LOAD_NETWORK, [networkId]);
    },
  };
}

const ConnectedFetchNetworkController = connect(
  mapStateToProps,
  mapDispatchToProps,
)(SimpleFetchController);

ConnectedFetchNetworkController.propTypes = {
  networkId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export { ConnectedFetchNetworkController };
